import React, {useEffect, useRef} from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./dates.css";
import {API_URL} from "../../../../../../../URL";
import {useDispatch} from "react-redux";
import {REMOVE_CARD_DATE, SET_CARD_DATE} from "../../../../../../../store/constants";

export const DatesModal = ({
                               onClose,
                               position,
                               startDate,
                               setStartDate,
                               dueDate,
                               setDueDate,
                               startDateEnabled,
                               setStartDateEnabled,
                               dueDateEnabled,
                               setDueDateEnabled,
                               card,
                               setIsDatesOpen
                           }) => {
    const modalRef = useRef(null);
    const dispatch = useDispatch();
    console.log(dueDateEnabled);
    console.log(startDateEnabled);
    const saveDate = async () => {

        const formattedStartDate = startDate.toLocaleDateString("en-US", {
            year: "numeric",
            month: "long",
            day: "numeric",
        });
        const formattedDueDate = dueDate.toLocaleDateString("en-US", {
            year: "numeric",
            month: "long",
            day: "numeric",
        });
        const response = await fetch(API_URL + "/post/handle_date/", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                id: card?.id,
                start_date: formattedStartDate,
                due_date: formattedDueDate
            })
        })
        const data = await response.json();
        dispatch({
            type: SET_CARD_DATE,
            payload: {
                card: card?.id,
                ...data
            }
        });
        setIsDatesOpen(false);
    };
    const removeDate = async () => {
        const id = card?.date?.id;
        const response = await fetch(API_URL + "/delete/remove_date/", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                id,
            })
        })

        setIsDatesOpen(false);

        dispatch({type: REMOVE_CARD_DATE, payload: id})
    }
    useEffect(() => {
        if (card?.date?.start_date) {
            setStartDate(new Date(card.date.start_date));
        }

        if (card?.date?.due_date) {
            setDueDate(new Date(card.date.due_date));
        }
    }, [card]);
    
    return (
        <div
            className="datesModal"
            ref={modalRef}
            style={{
                top: position.top - 50,
                left: position.left,
            }}
        >
            <div className="datesModal__header">
                <h3>Dates</h3>

                <button
                    type="button"
                    className="datesModal__close"
                    onClick={onClose}
                >
                    ✕
                </button>
            </div>

            {/* Due date calendar */}
            <div className="datesModal__calendar">
                <DatePicker
                    inline
                    selected={dueDate}
                    onChange={(date) => setDueDate(date)}
                    disabled={!dueDateEnabled}
                />
            </div>

            {/* Start date */}
            <div className="datesModal__section">
                <label className="datesModal__checkRow">
                    <input
                        type="checkbox"
                        checked={startDateEnabled}
                        onChange={() =>
                            setStartDateEnabled((prev) => !prev)
                        }
                    />

                    <div className="datesModal__fieldWrap">
                        <span>Start date</span>

                        <DatePicker
                            selected={startDate}
                            onChange={(date) => setStartDate(date)}
                            dateFormat="M/d/yyyy"
                            disabled={!startDateEnabled}
                            className="datesModal__input"
                        />
                    </div>
                </label>
            </div>

            {/* Due date input */}
            <div className="datesModal__section">
                <label className="datesModal__checkRow">
                    <input
                        type="checkbox"
                        checked={dueDateEnabled}
                        onChange={() =>
                            setDueDateEnabled((prev) => !prev)
                        }
                    />

                    <div className="datesModal__fieldWrap">
                        <span>Due date</span>
                        <div className="datesModal__checkRow">
                            <DatePicker
                                selected={dueDate}
                                onChange={(date) => setDueDate(date)}
                                dateFormat="M/d/yyyy"
                                disabled={!dueDateEnabled}
                                className="datesModal__input"
                            />
                            <input
                                type="time"
                                className="datesModal__input datesModal__timeInput"
                                disabled={!dueDateEnabled}
                                value={
                                    dueDate
                                        ? `${String(dueDate.getHours()).padStart(2, "0")}:${String(
                                            dueDate.getMinutes()
                                        ).padStart(2, "0")}`
                                        : ""
                                }
                                onChange={(e) => {
                                    const [hours, minutes] = e.target.value.split(":");

                                    const newDate = new Date(dueDate || new Date());

                                    newDate.setHours(Number(hours));
                                    newDate.setMinutes(Number(minutes));

                                    setDueDate(newDate);
                                }}
                            />
                        </div>
                    </div>
                </label>
            </div>
            <div className="datesModal__checkRow">
                <button
                    className="cardModal__saveBtn"
                    onClick={saveDate}
                >
                    Save
                </button>
                {
                    Object.keys(card?.date || {}).length !== 0 && (
                        <button
                            type="button"
                            className="button__red"
                            onClick={removeDate}
                        >
                            Remove
                        </button>
                    )
                }
            </div>
        </div>
    );
};